import { render, staticRenderFns } from "./NoFound.vue?vue&type=template&id=0d744456&scoped=true&"
import script from "./NoFound.vue?vue&type=script&lang=js&"
export * from "./NoFound.vue?vue&type=script&lang=js&"
import style0 from "./NoFound.vue?vue&type=style&index=0&id=0d744456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d744456",
  null
  
)

export default component.exports